
import { Doughnut } from "vue-chartjs";

const WARNA = [
  "#1E88E5",
  "#43A047",
  "#FB8C00",
  "#8E24AA",
  "#E53935",
  "#00897B",
  "#6D4C41",
  "#546E7A",
  "#BDBDBD"
];

export default {
  extends: Doughnut,
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] }
  },
  computed: {
    chartData(): any {
      return {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: this.labels.map(
              (_label: string, i: number) => WARNA[i % WARNA.length]
            ),
            borderWidth: 2
          }
        ]
      };
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 60,
        legend: { position: "right", labels: { boxWidth: 12 } }
      }
    };
  },
  mounted() {
    (this as any).renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        (this as any).renderChart(this.chartData, this.options);
      }
    }
  }
};
